import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncBulkOpsCoreEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-bulkops-core-entrypoint" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
